import { useMemo } from "react";
import { usePlans, useSubscription } from "./useSubscriptionQuery";
import {
	canCreateWithPlanLimit,
	findFreePlan,
	getCurrentPlan,
	getPlanLimit,
	hasPlanFeature,
	type PlanFeatureFlagKey,
	type PlanLimitKey,
} from "../utils";

export const useEntitlements = () => {
	const subscriptionQuery = useSubscription();
	const plansQuery = usePlans();
	const currentPlan = useMemo(
		() => getCurrentPlan(subscriptionQuery.data),
		[subscriptionQuery.data],
	);

	const plan = useMemo(
		() => currentPlan ?? findFreePlan(plansQuery.data) ?? null,
		[currentPlan, plansQuery.data],
	);
	const isLoading =
		subscriptionQuery.isLoading || (!currentPlan && plansQuery.isLoading);

	return {
		...subscriptionQuery,
		isLoading,
		plan,
		hasFeature: (flag: PlanFeatureFlagKey) => hasPlanFeature(plan, flag),
		getLimit: (limitKey: PlanLimitKey) => getPlanLimit(plan, limitKey),
		isAtLimit: (limitKey: PlanLimitKey, currentCount: number) =>
			!canCreateWithPlanLimit(plan, limitKey, currentCount),
		canCreate: (limitKey: PlanLimitKey, currentCount: number) =>
			canCreateWithPlanLimit(plan, limitKey, currentCount),
	};
};
